import React from 'react';

import {
  PageWrapper,
  Container,
  Breadcrumbs,
  Row,
  Col,
  Box,
  Button,
  Heading,
  InputField,
  InputSelect,
  Icon,
  NavLink
} from 'base-ui';

// Components
import ResultConsult from '../../../components/Consultation/ResultConsult';

// Data
const resultsConsults = [
  {
    id: 1,
    thumb: './img/dummy/service-1.png',
    title: 'Terapia de pareja',
    price: '75€',
    type: 'Consulta',
    stars: 3,
    opinions: '3 valoracion',
  },
  {
    id: 2,
    thumb: './img/dummy/service-2.png',
    title: 'Trastorno del pánico',
    price: '70€',
    type: 'Consulta',
    stars: 5,
    opinions: '8 valoracion'
  },
  {
    id: 3,
    thumb: './img/dummy/service-3.png',
    title: 'Niños y adolescentes felices',
    price: '80€',
    type: 'Consulta',
    stars: 4,
    opinions: '10 valoracion',
  },
  {
    id: 4,
    thumb: './img/dummy/service-1.png',
    title: 'Trastorno del pánico',
    price: '85€',
    type: 'Consulta',
    stars: 3,
    opinions: '2 valoracion',
  },
  {
    id: 5,
    thumb: './img/dummy/service-2.png',
    title: 'Resolver problemas pacificamente',
    price: '65€',
    type: 'Consulta',
    stars: 2,
    opinions: '',
  },
];

const Archive = () => (
  <PageWrapper config={{ title: 'Consultation Archive', bodyClasses: 'consultation archive' }}>

    <Box tag="main" id="site-main">

      <Box tag="section">
        <Container fluid wrap>
          <Row>
            <Col xs="12">
              <Breadcrumbs>
                <NavLink href="/consultation">
                  <Icon prefix="fas" name="home" className="main-color" />
                  {' '}
                  Inicio
                </NavLink>
                <Box tag="span">Consultas</Box>
              </Breadcrumbs>
            </Col>
          </Row>
        </Container>
      </Box>

      <Box id="recent-consultation">
        <Container fluid wrap>
          <Row>
            <Col xs="12">
              <Heading type="h1" className="margin-top-big label main-font titles-color font-x-big">
                Todas las consultas
              </Heading>
              <Row className="between-xs margin-bottom-big">
                <Col xs="6" sm="3">
                  <InputSelect
                    name="select_filter"
                    className="without-shadow"
                    // autocomplete
                    placeholder="Filtrar por categoria"
                    options={[
                      { value: 'Educación', label: 'Educación' },
                      { value: 'Relaciones', label: 'Relaciones' },
                      { value: 'Adolescentes', label: 'Adolescentes' },
                      { value: 'Depresión', label: 'Depresión' },
                      { value: 'Comunicación', label: 'Comunicación' },
                      { value: 'Ansiedade', label: 'Ansiedade' },
                      { value: 'Fobias', label: 'Fobias' },
                      { value: 'Adiccion', label: 'Adiccion' },
                      { value: 'Coaching', label: 'Coaching' },
                      { value: 'Pareja', label: 'Pareja' },
                      { value: 'Duelo', label: 'Duelo' },
                      { value: 'Psicologia Clinica', label: 'Psicologia Clinica' },
                      { value: 'Autoestima', label: 'Autoestima' },
                      { value: 'Coaching', label: 'Coaching' },
                    ]}
                  />
                </Col>
                <Col xs="6" sm="3">
                  <InputSelect
                    name="select_order"
                    className="without-shadow"
                    options={[
                      { value: '', label: 'Ordenar por' },
                    ]}
                  />
                </Col>
                <Col xs="12" sm="6">
                  <Row>
                    <Col xs="8">
                      <Box className="field-with-icon">
                        <Icon prefix="fas" name="search icon" />
                        <InputField
                          type="text"
                          name="input_search"
                          className="input without-shadow full"
                          placeholder="Buscar por nombre..."
                        />
                      </Box>
                    </Col>
                    <Col xs="4">
                      <Button className="btn main-bg white-border full white-color">Buscar</Button>
                    </Col>
                  </Row>
                </Col>
                <hr />
              </Row>
              <Box className="consultations">
                { resultsConsults.map((result) => (
                  <ResultConsult
                    key={result.id}
                    data={{
                      thumb: result.thumb,
                      title: result.title,
                      price: result.price,
                      type: result.type,
                      stars: result.stars,
                      opinions: result.opinions,
                    }}
                  />
                ))}
              </Box>
              <hr />
              <Box className="align-center display-block">
                <NavLink to="#" className="btn big main-bg main-border white-color">Cargar más</NavLink>
              </Box>
            </Col>
          </Row>
        </Container>
      </Box>

    </Box>
    {/* end main section */}

  </PageWrapper>
);

export default Archive;
